
import { Injectable } from '@angular/core';
import { Config } from '../app.config';

@Injectable()
export class LangService {

    public current = "de_de";

}